import type { Provider } from '@angular/core';

import { provideTellentAssistantRenderPresenter } from '@core/tellent-assistant-contracts';

import { AssistantPresentChartComponent } from './present-chart.component';
import type { PresentChartArgs } from './present-chart.types';

export const providePresentChartClientTool: Provider =
  provideTellentAssistantRenderPresenter<PresentChartArgs>({
    id: 'presentChart',
    component: AssistantPresentChartComponent,
  });
